import { Dialog } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import MyDialogContent from "@/components/MyDialogContent";
import { formatDateTime12 } from "@/utils/helpers";
import {
  formatSupportTicketType,
  resolveSupportCreatedByName,
} from "./supportTicketConstants";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ticket: Record<string, unknown> | null;
};

export function SupportTicketViewDialog({ open, onOpenChange, ticket }: Props) {
  const notes = Array.isArray(ticket?.supportTicketNotes)
    ? [...(ticket.supportTicketNotes as Record<string, unknown>[])]
    : [];

  return (
    <Dialog open={open && !!ticket} onOpenChange={onOpenChange}>
      <MyDialogContent heading="Ticket Details">
        {ticket ? (
        <div className="mt-2 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-muted-foreground text-xs">Ticket ID</Label>
              <p className="font-medium">{String(ticket.ticketId ?? "—")}</p>
            </div>
            <div>
              <Label className="text-muted-foreground text-xs">Ticket Type</Label>
              <p className="font-medium">{formatSupportTicketType(ticket.ticketType)}</p>
            </div>
            <div>
              <Label className="text-muted-foreground text-xs">Customer</Label>
              <p className="font-medium">
                {String((ticket.customer as { name?: string } | undefined)?.name ?? "—")}
              </p>
            </div>
            <div>
              <Label className="text-muted-foreground text-xs">Created By</Label>
              <p className="font-medium">{resolveSupportCreatedByName(ticket)}</p>
            </div>
            <div>
              <Label className="text-muted-foreground text-xs">Created At</Label>
              <p className="font-medium">
                {ticket.createdAtImpilo
                  ? formatDateTime12(String(ticket.createdAtImpilo))
                  : "—"}
              </p>
            </div>
            <div>
              <Label className="text-muted-foreground text-xs">Last Updated</Label>
              <p className="font-medium">
                {ticket.lastUpdatedImpilo
                  ? formatDateTime12(String(ticket.lastUpdatedImpilo))
                  : "—"}
              </p>
            </div>
          </div>
          {notes.length > 0 ? (
            <div>
              <Label className="text-muted-foreground text-xs">Notes</Label>
              <div className="mt-1 space-y-2">
                {notes.reverse().map((note, idx) => (
                  <div key={idx} className="bg-muted/50 rounded-md p-3 text-sm">
                    <p className="whitespace-pre-wrap">{String(note?.note ?? "")}</p>
                    <p className="text-muted-foreground mt-1 text-xs">
                      {String((note?.createdByUser as { name?: string } | undefined)?.name ?? "")}
                      {(note?.createdByUser as { name?: string } | undefined)?.name ? " - " : ""}
                      {note?.createdAt ? formatDateTime12(String(note.createdAt)) : ""}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
        ) : null}
      </MyDialogContent>
    </Dialog>
  );
}
